// client/plugins/pasteHandlerPlugin.ts
import { DOMParser as ProsemirrorDOMParser } from "prosemirror-model";
import { Plugin } from "prosemirror-state";
var pasteHandler = new Plugin({
  props: {
    handlePaste(view, event, slice) {
      const clipboardData = event.clipboardData;
      if (!clipboardData)
        return false;
      const html = clipboardData.getData("text/html");
      if (!html)
        return false;
      const dom = new DOMParser().parseFromString(html, "text/html");
      const parsedContents = ProsemirrorDOMParser.fromSchema(view.state.schema).parse(dom.body).content;
      const { state, dispatch } = view;
      const { $from } = state.selection;
      if (!$from.parent.type.spec.content?.includes("block")) {
        const tr = state.tr;
        let insertPos = $from.start();
        let replaceFirstNode = false;
        if ($from.parent.content.size === 0) {
          replaceFirstNode = true;
        }
        parsedContents.forEach((node, index) => {
          if (replaceFirstNode && index === 0) {
            const paragraphStart = $from.before();
            const paragraphEnd = $from.after();
            tr.replaceWith(paragraphStart, paragraphEnd, node);
            insertPos = paragraphStart + node.nodeSize;
          } else {
            tr.insert(insertPos, node);
            insertPos += node.nodeSize;
          }
        });
        dispatch(tr);
        return true;
      }
      return false;
    }
  }
});
export {
  pasteHandler
};
